module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('h2', [_vm._v("Quer ficar por dentro do Laboratório da Luna?")]), _vm._v(" "), _c('p', [_vm._v("\n    Cadastra-se e receba nossas novidades antes de todo mundo!\n  ")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has('email')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.model.email),
      expression: "model.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "seu e-mail"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-feedback",
    attrs: {
      "show": _vm.errors.has('email')
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-luna",
    attrs: {
      "disabled": _vm.sending,
      "type": "submit"
    }
  }, [_vm._v("Enviar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0336aaf3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 58
// module chunks = 0